import React, { useMemo } from 'react';

const ParticlesBackground = () => {
  const particles = useMemo(() => {
    return Array.from({ length: 60 }).map((_, i) => {
      const size = Math.random() * 3 + 1;
      const startX = Math.random() * 100;
      const startY = Math.random() * 100;
      const tx = (Math.random() - 0.5) * 200;
      const ty = (Math.random() - 0.5) * 200;
      const duration = 10 + Math.random() * 20;
      const delay = Math.random() * 15;
      const isGold = Math.random() > 0.65;
      return {
        id: i,
        size,
        startX,
        startY,
        tx,
        ty,
        duration,
        delay,
        isGold,
      };
    });
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* Deep gradient base */}
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at 20% 0%, rgba(30, 60, 150, 0.25), transparent 50%), radial-gradient(ellipse at 80% 100%, rgba(255, 140, 50, 0.18), transparent 50%), #050816'
      }} />

      {/* Subtle grid */}
      <div className="absolute inset-0 grid-pattern opacity-40" />

      {/* Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute rounded-full"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            left: `${p.startX}%`,
            top: `${p.startY}%`,
            background: p.isGold ? '#ffb74d' : '#4facfe',
            boxShadow: p.isGold
              ? '0 0 8px rgba(255, 167, 38, 0.9), 0 0 14px rgba(255, 167, 38, 0.5)'
              : '0 0 8px rgba(79, 172, 254, 0.9), 0 0 14px rgba(79, 172, 254, 0.5)',
            opacity: 0,
            animation: `particle-drift ${p.duration}s linear ${p.delay}s infinite`,
            ['--tx']: `${p.tx}px`,
            ['--ty']: `${p.ty}px`,
          }}
        />
      ))}
    </div>
  );
};

export default ParticlesBackground;
